document.addEventListener('click', e => {
  const dropdown = e.target.closest('.Our_comparison_inneritem_right_table_innerlist_new');
  const title = e.target.closest('.Our_comparison_inneritem_right_table_innerlist_title_new');
  const item  = e.target.closest('.Tabs_common_inner_new');

  // Close ALL dropdowns if click is outside
  if (!dropdown) {
    document
      .querySelectorAll('.Our_comparison_inneritem_right_table_innerlist_new.open')
      .forEach(el => el.classList.remove('open'));
    return;
  }

  // Toggle dropdown on title click
  if (title) {
    dropdown.classList.toggle('open');
  }

  // On item click: set text + close dropdown
  if (item) {
    dropdown.querySelector(
      '.Our_comparison_inneritem_right_table_innerlist_title_new span.Our_comparison_inneritem_right_table_innerlist_title_info_new'
    ).textContent = item.textContent.trim();

    dropdown.classList.remove('open');
  }
});

/* Comparison table tabs. In the old theme this lived in the global custom.js
   (InitTabs); ported here and scoped to this section. The old version also
   bound a mouseenter on the Debut header menu, which does not exist in this
   theme, so that part is dropped. */
(function () {
  function initComparisonTabs() {
    document.querySelectorAll('.Our_comparison_main_new .Tabs_common_main_new').forEach(function (container) {
      if (container.dataset.tabsBound === 'true') return;
      container.dataset.tabsBound = 'true';

      var tabs = container.querySelectorAll('.Tabs_common_inner_new');
      var contents = container.querySelectorAll('.tabcontent');

      function activateTab(tab) {
        var tabId = tab.getAttribute('tab_id');
        if (!tabId) return;
        tabs.forEach(function (t) { t.classList.remove('active'); });
        contents.forEach(function (c) { c.style.display = 'none'; });
        tab.classList.add('active');
        var target = container.querySelector('.' + tabId + '_open');
        if (target) target.style.display = 'block';
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activateTab(tab); });
      });

      var firstActive = container.querySelector('.Tabs_common_inner_new.active') || tabs[0];
      if (firstActive) activateTab(firstActive);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComparisonTabs);
  } else {
    initComparisonTabs();
  }
  document.addEventListener('shopify:section:load', initComparisonTabs);
})();
